import styled from 'styled-components';

export const StyledBasicCheckbox = styled.div`
  display: flex;
  align-items: center;

  > input[type='checkbox'] {
    position: absolute;
    visibility: hidden;
  }

  .cbx {
    margin: auto;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      vertical-align: middle;
      transform: translate3d(0, 0, 0);
    }

    span:first-child {
      position: relative;
      width: 18px;
      height: 18px;
      border-radius: 3px;
      transform: scale(1);
      vertical-align: middle;
      border: 1px solid var(--color-pale-gray);
      background-color: var(--color-white);
      transition: all 0.2s ease;

      svg {
        position: absolute;
        top: 3px;
        left: 2px;
        fill: none;
        stroke: var(--color-white);
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 16px;
        stroke-dashoffset: 16px;
        transition: all 0.3s ease;
        transition-delay: 0.1s;
        transform: translate3d(0, 0, 0);
      }

      &:before {
        content: '';
        width: 100%;
        height: 100%;
        background: var(--color-primary-blue);
        display: block;
        transform: scale(0);
        opacity: 1;
        border-radius: 50%;
      }
    }

    span:last-of-type {
      color: var(--color-white);
      padding-left: 8px;
    }

    &:hover span:first-child {
      border-color: var(--color-primary-blue);
    }
  }

  .inp-cbx:checked + .cbx span:first-child {
    background: var(--color-primary-blue);
    border-color: var(--color-primary-blue);
    animation: wave-46 0.4s ease;
  }

  .inp-cbx:checked + .cbx span:first-child svg {
    stroke-dashoffset: 0;
  }

  /* .inp-cbx:checked + .cbx span:first-child:before {
    transform: scale(3.5);
    opacity: 0;
    transition: all 0.6s ease;
  } */

  @keyframes wave-46 {
    50% {
      transform: scale(0.9);
    }
  }
`;
